import React from 'react';

let animation = null;

class PulsingDot extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.size = this.props.size;
    this.width = this.size;
    this.height = this.size;
    this.data = new Uint8Array(this.size * this.size * 4);
    this.animateDot = this.animateDot.bind(this);
    this.onClick = this.props.onClick;
  }

  componentDidMount() {
    animation = window.requestAnimationFrame(this.animateDot);
  }

  animateDot() {
    const duration = 1000;
    const t = (performance.now() % duration) / duration;
     
    const radius = this.size / 2 * 0.2;
    const outerRadius = this.size / 2 * 0.7 * t + radius;
    const canvas = this.canvasRef.current;
    let context;

    if (canvas) {
      context = canvas.getContext('2d');
       
      // draw outer circle
      context.clearRect(0, 0, this.width, this.height);
      context.beginPath();
      context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
      context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')';
      context.fill();
       
      // draw inner circle
      context.beginPath();
      context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
      context.fillStyle = 'rgba(255, 0, 0, 1)';
      // context.strokeStyle = 'white';
      context.lineWidth = 2 + 4 * (1 - t);
      context.fill();
      // context.stroke();
       
      // update this image's data with data from the canvas
      // this.data = context.getImageData(0, 0, this.width, this.height).data;
      animation = window.requestAnimationFrame(this.animateDot);
    }
  }

  onClick() {
    console.log('clicked');
    this.props.onClick()
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(animation);
  }

  render() {
    return <canvas id="CJ" width={this.width} height={this.height} ref={this.canvasRef} onClick={this.onClick}/>;
  }
}

export default PulsingDot


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/pulsingDot.js